import { render, staticRenderFns } from "./MaterialCreativeIndex.vue?vue&type=template&id=46dd0b17&scoped=true&"
import script from "./MaterialCreativeIndex.vue?vue&type=script&lang=js&"
export * from "./MaterialCreativeIndex.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCreativeIndex.vue?vue&type=style&index=0&id=46dd0b17&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd0b17",
  null
  
)

export default component.exports